import Icon from 'flow/components/ui-components/Icon';
import { generateRandomString } from 'flow/utils';
import { isURL } from 'flow/utils/call-widget-utils';
import { twMerge } from 'tailwind-merge';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const LinkIcon = (props) => {
    const { primaryLabel, secondaryLabel, actionUrl, actionIcon, darkMode } =
        props;
    let { actionCallback } = props;

    const [typeOrIcon, setTypeOrIcon] = useState(
        getTypeText(secondaryLabel, darkMode),
    );
    const key = generateRandomString();

    actionCallback = actionCallback || (() => {});
    const linkEnabled = isURL(actionUrl);

    return (
        <a
            key={primaryLabel}
            href={linkEnabled ? actionUrl : undefined}
            className={twMerge(
                'flex items-center rounded-sm p-0.5 text-sm no-underline',
                darkMode
                    ? 'text-white hover:bg-gray-500'
                    : 'text-black hover:bg-gray-200',
                linkEnabled
                    ? `cursor-pointer ${
                          darkMode ? 'text-gray-600' : 'text-gray-200'
                      }`
                    : 'cursor-default',
            )}
            onMouseEnter={
                actionIcon && linkEnabled
                    ? () => {
                          setTypeOrIcon(
                              getRightLinkIcon(key, actionIcon, darkMode),
                          );
                      }
                    : () => {}
            }
            onMouseLeave={
                actionIcon && linkEnabled
                    ? () => {
                          setTypeOrIcon(getTypeText(secondaryLabel, darkMode));
                      }
                    : () => {}
            }
            onClick={(event) => {
                event.preventDefault();
                actionCallback();
                if (actionUrl && linkEnabled) {
                    window.open(actionUrl, '_blank');
                }
            }}
        >
            <div
                className={twMerge(
                    'flex-1 overflow-hidden text-ellipsis whitespace-nowrap',
                    darkMode ? 'text-gray-400' : 'text-gray-600',
                )}
            >
                {primaryLabel || '-'}
            </div>
            {typeOrIcon}
        </a>
    );
};

LinkIcon.propTypes = {
    primaryLabel: PropTypes.string,
    secondaryLabel: PropTypes.string,
    actionUrl: PropTypes.string,
    actionIcon: PropTypes.node,
    actionCallback: PropTypes.func,
    darkMode: PropTypes.bool.isRequired,
};

const getTypeText = (type, darkMode) => (
    <div
        className={twMerge(
            'overflow-hidden font-bold text-ellipsis whitespace-nowrap',
            darkMode ? 'text-white' : 'text-black',
        )}
    >
        {type || ''}
    </div>
);

const getRightLinkIcon = (key, iconKey, darkMode) =>
    iconKey ? (
        <Icon
            iconKey={iconKey}
            key={key}
            className={twMerge(
                'size-5',
                darkMode ? 'text-white' : 'text-black',
            )}
        />
    ) : null;

export default React.memo(LinkIcon);
